import axios from "axios";
import settings from "utils/settings";

const chargerUrl = `${settings.chargerUrl}api`;
const ENDPOINT = "admin/package";

export const requestPackageGetList = () =>
  axios.post(`${chargerUrl}/${ENDPOINT}/list`, {
    criteria: [],
  });

export const requestPackageAdd = (data) =>
  axios.post(`${chargerUrl}/${ENDPOINT}`, data);

export const requestPackageAddImage = (id, file) => {
  const formData = new FormData();
  formData.append("image", file, file.name);
  return axios.patch(`${chargerUrl}/${ENDPOINT}/${id}/image`, formData);
};

export const requestPackageGetImage = (id) =>
  axios.get(`${chargerUrl}/${ENDPOINT}/${id}/image`, {
    responseType: "blob",
  });

export const requestPackageAssign = (packageId, usersIdArr) =>
  axios.post(`${chargerUrl}/${ENDPOINT}/${packageId}/asign/batch`, usersIdArr);



// WEBPACK FOOTER //
// ./src/actions/chargers/package/requests.js